import { Sentry } from '@marpla/core';
import { ApplicationErrorPage } from '@marpla/core/application-error';

interface SentryErrorBoundaryProps {
  children: React.ReactNode;
}

export default function SentryErrorBoundary(props: SentryErrorBoundaryProps): JSX.Element {
  return (
    <Sentry.ErrorBoundary
      fallback={<ApplicationErrorPage homeHref="/report/project" isSupportChatEnabled />}
    >
      {props.children}
    </Sentry.ErrorBoundary>
  );
}
